"use strict";
import { SERVICE_MAPPING_CODE } from "./Constants";

class CommonUtil {
  // 객체가 Null인지 체크
  isEmpty(obj) {
    return (
      typeof obj === "undefined" ||
      obj === null ||
      !obj ||
      obj.length === 0 ||
      obj === "" ||
      !/[^\s]/.test(obj) ||
      /^\s*$/.test(obj) ||
      (obj !== null && typeof obj === "object" && !Object.keys(obj).length)
    );
  }

  // 객체가 Null이 아닌지 체크
  isNotEmpty(obj) {
    return !this.isEmpty(obj);
  }

  calculateAge(birth) {
    if (this.isEmpty(birth)) {
      return 0;
    }

    const birthArr = birth.split("-");
    const today = new Date();
    const birthDate = new Date(birthArr[0], birthArr[1], birthArr[2]);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() + 1 - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  DateToconvertSplit(strDate, splitItem = "-") {
    if (this.isEmpty(strDate)) {
      return "";
    }

    const dateArr = strDate.split(splitItem);
    if (dateArr.length !== 3) {
      return "";
    }

    return `${dateArr[0]}년 ${dateArr[1]}월 ${dateArr[2]}일`;
  }

  isMobile() {
    const mobile =
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(
        window.navigator.userAgent
      );
    const tablet = /iPad|tablet/i.test(window.navigator.userAgent);
    return mobile || tablet;
  }

  checkBrowser() {
    const userAgent = window.navigator.userAgent.toLocaleLowerCase();
    let browserName = "";
    switch (true) {
      case userAgent.indexOf("edge") > -1:
        browserName = "edge"; //엣지
        break;
      case userAgent.indexOf("edg/") > -1:
        browserName = "edgeChrome"; //크롬기반 엣지
        break;
      case userAgent.indexOf("opr") > -1 && !!window.opr:
        browserName = "opera"; //오페라
        break;
      case userAgent.indexOf("chrome") > -1 && !!window.chrome:
        browserName = "chrome"; //크롬
        break;
      case userAgent.indexOf("trident") > -1:
        browserName = "ie"; //ie
        break;
      case userAgent.indexOf("firefox") > -1:
        browserName = "firefox"; //firefox
        break;
      case userAgent.indexOf("safari") > -1:
        browserName = "safari"; //safari
        break;
    }

    return browserName;
  }

  // 문자열 공백제거
  replaceSpace(str) {
    return str.replace(/ /g, "");
  }

  // 특수문자, 공백 제거
  replaceSpaceAndSpecialCharacter(string) {
    return string.replace(/[^a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힣\u318D\u119E\u11A2\u2022\u2025a\u00B7\uFE55]/g, "");
  }

  // 한글, 공백 문자 제거
  replaceKoreanAndSpace(string) {
    return string.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣\s]/g, "");
  }

  // 한글 제외한 문자 제거
  replaceNotKorean(string) {
    return string.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣]/g, "");
  }

  // 숫자, 영문, "@", "." 제외한 문자 제거
  replaceNotId(string) {
    return string.replace(/[^a-zA-Z0-9@.]/g, "");
  }

  ///핸드폰 포멧
  phoneFormat = (input) => {
    return `${input}`.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  };

  // 생일 포맷
  birthFormat(year, month, day, format = "-") {
    if (this.isEmpty(year) || this.isEmpty(month) || this.isEmpty(day)) {
      return "";
    }

    return year + format + month.toString().padStart(2, "0") + format + day.toString().padStart(2, "0");
  }

  ///핸드폰 마스킹
  phoneHyphenMarsking = (phone) => {
    return phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-****-$3`);
  };

  ///핸드폰 마스킹
  phoneMarsking = (phone) => {
    const phone1 = phone.substring(0, 3);
    const phone3 = phone.substring(7);
    return `${phone1}****${phone3}`;
  };

  ///이메일 마스킹
  emailMarsking = (email) => {
    const emailArr = email.split("@");
    const emailId = emailArr[0];
    const emailIdLength = emailId.length;

    let emailBefore = emailId;
    if (emailIdLength > 3) {
      emailBefore = `${emailId.slice(0, -3)}***`;
    } else {
      emailBefore = `${"*".repeat(emailIdLength)}`;
    }
    return `${emailBefore}@${emailArr[1]}`;
  };
  ///이메일 마스킹
  emailMarskingType2 = (email) => {
    const emailArr = email.split("@");
    const emailId = emailArr[0];
    const emailIdLength = emailId.length;

    let emailBefore = emailId;
    if (emailIdLength < 7) {
      emailBefore = `${emailId.slice(0, 2)}${"*".repeat(emailIdLength - 2)}`;
    } else {
      emailBefore = `${emailId.slice(0, 3)}${"*".repeat(emailIdLength - 3)}`;
    }
    return `${emailBefore}@${emailArr[1]}`;
  };

  // 두 배열 비교
  checkedComparisonList(arr1, arr2) {
    return arr1.length === arr2.length && arr1.filter((x) => !arr2.includes(x)).length < 1;
  }

  // Byte 길이 체크
  getByteLength(string) {
    let byteLength = 0;

    for (let i = 0; i < string.length; i++) {
      const charCode = string.charCodeAt(i);

      if (charCode <= 0x7f) {
        byteLength += 1;
      } else if (charCode <= 0xffff) {
        byteLength += 2;
      } else {
        byteLength += 3;
      }
    }

    return byteLength;
  }

  // SERVICE_MAPPING_CODE의 value(SVC코드)로 key(OTAF코드)를 반환
  getServiceMappingKey(serviceCode) {
    return Object.keys(SERVICE_MAPPING_CODE).find((key) => SERVICE_MAPPING_CODE[key] === serviceCode) ?? null;
  }

  // 문자열을 특정 바이트 길이에 맞게 잘라주는 함수
  cutStringByByte(string, maxByte) {
    let byteCount = 0;
    const strLength = string.length;
    let cutLength = string.length;

    for (let i = 0; i < strLength; i++) {
      byteCount += string.charCodeAt(i) > 255 ? 2 : 1;
      if (byteCount > maxByte) {
        cutLength = i;
        break;
      }
    }

    return string.substring(0, cutLength);
  }
}

const commonUtil = new CommonUtil();
export default commonUtil;
